import React from 'react';
import PropTypes from 'prop-types';
import { InfoButtonWithOnlineHelp } from 'sharedComponents/InfoButtonWithOnlineHelp';
import {
    IconAnomalyDetection,
    IconCondition,
    IconRefresh
} from 'svgIcons/MotionPortalIcons';
import { maxAnomalyLevel } from './CoolingAnomalyChart/constants';
import { translate } from 'helpers/translateHelper';
import { getKpiConditionLabel, getKpiConditionStatus } from './conditionStatus';

const DriveAssetStatusIndicator = ({
    anomalyDetectionKPI,
    title,
    levelLabel,
    getAnomalyOverallLevel,
    anomalyKPIKey,
    InfoContent,
    descriptionText,
    isRetraining,
    isPrivilegedUser,
    setRetrainingModel
}) => {
    const conditionLabel = getKpiConditionLabel(anomalyDetectionKPI);
    const condition = getKpiConditionStatus(anomalyDetectionKPI);
    const level = getAnomalyOverallLevel(anomalyKPIKey);
    const isTolerable = level > 0;
    const isUnknown = conditionLabel === 'Unknown';

    const currentLevel = (() => {
        if (isTolerable) { return `${level}/${maxAnomalyLevel}`; }
        if (isUnknown) { return conditionLabel; }
        return `0/${maxAnomalyLevel}`;
    })();

    const latestAnomalyLevel = `${levelLabel}: ${currentLevel}`;
    const Iconanomaly = isTolerable
        ? <span><IconAnomalyDetection /></span>
        : <span><IconCondition condition={condition} /></span>;

    // Retraining control (button or badge)
    let retrainControl = null;
    if (isPrivilegedUser) {
        if (isRetraining) {
            retrainControl =
                <span className='retraining-badge' aria-disabled='true'>
                    <IconRefresh width={'16px'} height={'16px'} color={'rgba(0, 0, 0, 0.40)'} />
                    <span>{translate('ABB.Powertrain.Frontend.retrainingLabel')}</span>
                </span>
                ;
        } else {
            retrainControl =
                <button
                    type='button'
                    className='retrain-model-button'
                    onClick={() => setRetrainingModel(true)}
                >
                    <IconRefresh width={'16px'} height={'16px'} />
                    <span>{translate('ABB.Powertrain.Frontend.retrainModelLabel')}</span>
                </button>
                ;
        }
    }

    return (
        <div className='kpi_status_title'>
            <div className='retrain-model-container'>
                <b>
                    {isRetraining ? null : Iconanomaly}{title} {isRetraining ? '' : `(${latestAnomalyLevel})`}{' '}
                    {<InfoButtonWithOnlineHelp infoText={<InfoContent />} placement='top' withoutLink />}
                </b>
                {descriptionText &&
                    <p className='acs1000-cooling-anomaly-description'>{descriptionText}</p>
                }
                {retrainControl}
            </div>
        </div>
    );
};

DriveAssetStatusIndicator.propTypes = {
    anomalyDetectionKPI: PropTypes.object,
    title: PropTypes.string,
    levelLabel: PropTypes.string,
    getAnomalyOverallLevel: PropTypes.func,
    anomalyKPIKey: PropTypes.string,
    InfoContent: PropTypes.elementType,
    descriptionText: PropTypes.string,
    isRetraining: PropTypes.bool,
    isPrivilegedUser: PropTypes.bool,
    setRetrainingModel: PropTypes.func
};

export default DriveAssetStatusIndicator;
